import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=560e9e8d&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
import style0 from "./Auth.vue?vue&type=style&index=0&id=560e9e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e9e8d",
  null
  
)

export default component.exports